// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__container {
  background-color: white;
  flex: 1;
  padding: 10px;
  border: 1px solid #e8e8e8;
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__tree {
  padding: 0 20px;
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__droppable {
  min-height: 300px;
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__dashboardNameContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  height: 55px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__dashboardTitle {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__dashboardTitle:hover > .app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__viewDashboardButton {
    opacity: 0.5;
  }

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__viewDashboardButton {
  cursor: pointer;
  opacity: 0.3;
  padding-left: 6px;
  font-size: 18px;
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__viewDashboardButton:hover {
    opacity: 1 !important;
  }

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__crownIcon {
  font-size: 16px;
  padding-bottom: 4px;
  margin: 0 10px 0 -5px;
  color: var(--colors-yuzu-primaryColor);
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__widgetIcon {
  font-size: 16px;
  padding-bottom: 4px;
  margin-right: 10px;
  color: rgb(178, 185, 199);
}

.app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__widgetDefaultName {
  color: #bbbbbb;
  margin-left: 6px;
  text-transform: lowercase;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/Dashboards/ConfigTree/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,OAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EAEN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AAKnB;;AAHE;IACE,YAAY;EACd;;AAGF;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAKjB;;AAHE;IACE,qBAAqB;EACvB;;AAGF;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".container {\n  background-color: white;\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #e8e8e8;\n}\n\n.tree {\n  padding: 0 20px;\n}\n\n.droppable {\n  min-height: 300px;\n}\n\n.dashboardNameContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  height: 55px;\n  position: sticky;\n  top: 0;\n  // background-color: #ffffff;\n  z-index: 10;\n}\n\n.dashboardTitle {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 20px;\n\n  &:hover > .viewDashboardButton {\n    opacity: 0.5;\n  }\n}\n\n.viewDashboardButton {\n  cursor: pointer;\n  opacity: 0.3;\n  padding-left: 6px;\n  font-size: 18px;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n}\n\n.crownIcon {\n  font-size: 16px;\n  padding-bottom: 4px;\n  margin: 0 10px 0 -5px;\n  color: var(--colors-yuzu-primaryColor);\n}\n\n.widgetIcon {\n  font-size: 16px;\n  padding-bottom: 4px;\n  margin-right: 10px;\n  color: rgb(178, 185, 199);\n}\n\n.widgetDefaultName {\n  color: #bbbbbb;\n  margin-left: 6px;\n  text-transform: lowercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__container`,
	"tree": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__tree`,
	"droppable": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__droppable`,
	"dashboardNameContainer": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__dashboardNameContainer`,
	"dashboardTitle": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__dashboardTitle`,
	"viewDashboardButton": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__viewDashboardButton`,
	"crownIcon": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__crownIcon`,
	"widgetIcon": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__widgetIcon`,
	"widgetDefaultName": `app-pages-Project-Settings-Dashboards-ConfigTree-___styles-module__widgetDefaultName`
};
export default ___CSS_LOADER_EXPORT___;
